import {
    AccordionDefinition,
    AccordionDetailDefinition,
    AccordionItemDefinition,
    AccordionTitleDefinition
} from './accordion'
import {
    BreadcrumbLinkDefinition,
    LearningCenterBreadcrumbDefinition,
    StandardBreadcrumbDefinition,
    LearningCenterArticleBreadcrumbDefinition
} from './breadcrumb'
import {IconDefinition} from './icon-picker/icon-picker'
import {AccordionLinkDefinition} from './accordion-link'
import {IconLinksGridDefinition} from './icon-link-grid'
import {NavDrawerDefinition} from './navDrawer'
import {CategoriesDefinition} from 'hec/builder/blocks/categories'
import {HeadingDefinition} from './typography/heading'
import {BodyCopyDefinition} from './typography/body-copy'
import {EyebrowDefinition} from './typography/eyebrow'
import {
    ButtonDefinition,
    LinkDefinition,
    LinkWrapperDefinition,
    ToggleTextButtonDefinition,
    DownloadAssetButtonDefinition
} from './cta'
import {
    PopoverContainerDefinition,
    PopoverContentDefinition,
    PopoverTriggerDefinition,
    PopoverDefinition
} from './popover'
import {MinicartDefinition} from './minicart'
import {TextDefinition} from './text'
import {ContentTabsDefinition, TabButtonBoxDefinition, TabPanelBoxDefinition} from './content-tabs'
import {
    CarouselDefinition,
    CarouselContentDefinition,
    DeprecatedCarouselContentDefinition,
    DeprecatedCarouselDefinition,
    CarouselButtonDefinition,
    CarouselContentNavDefinition
} from './carousel'
import {ProductCarouselDefinition} from './product-carousel'
import {SearchDefinition} from './search'
import {ArticleTopicCardDefinition, ArticleCardDefinition, ArticleGridDefinition} from './article'
import {GoalTileDefinition} from '@/builder/blocks/goal'
import {GoalQuestionnaireDefinition} from './questionnaire'
import {LearningCenterModuleDefinition} from './learning-center-module'
import {EmailSignupDefinition} from './email-signup'
import {GoalBannerDefinition} from './goal-banner'
import {ThemeBoxDefinition} from '@/builder/blocks/theme-box'
import {LearningCenterLevelsDefinition} from './learning-center-levels'
import {
    GuestContentDefinition,
    AuthContentDefinition,
    LmnAllowedContentDefinition,
    LmnSuppressedContentDefinition
} from './content-by-access'
import {MainNavDefinition} from './main-nav'
import {StickyWrapperDefinition} from './sticky-wrapper'
import {ExpandableContentDefinition} from './expandable-content'
import {
    PerksAndRewardsSectionDefinition,
    UserNameDefinition,
    SignOutButtonDefinition
} from './account'
import {AccountDrawerDefinition} from './account-drawer'
import {ProductRecommendationsDefinition} from './product-recommendations'
import {BuilderDrawerFiltersDefinition} from './DrawerFilters'
import {ExpenseDashboardDefinition} from './expense-dashboard'
import {ModalContainerDefinition, ModalTriggerDefinition, ModalContentDefinition} from './modal'
import {
    ToggleButtonDefinition,
    ToggleContentDefinition,
    ToggleContextProviderDefinition
} from '@/builder/blocks/toggle'
import {TpaBalanceDefinition} from './tpa-balance'
import {CategoryProductGridDefinition} from './plp'
import {ProductTileDefinition} from './product-tile'
import {SortPopoverDefinition} from '../sort'
import {HeaderBannerDefinition} from './headerBanner'
import {AlertBarDefinition} from './alert-bar'
import {CategoryFiltersBannerDefinition} from './plp/filters'
import {PlpBuilderBlockDefinition} from './plp/plpBuilderBlock'
import {TrustArcBannerDefinition} from './trustarc-banner'
import {InteractiveSpendingToolDefinition} from './interactive-spending-tool'
import {RegisteredComponent} from '@builder.io/sdk-react'
import {ThreeColumnHeroDefinition} from './hero'
import {TwoColumnHeroDefinition} from './hero'
import {SingleColumnHeroDefinition} from './hero'
import {HomepageCarouselGridBuilderDefinition} from './homepage-carousel-grid'
import {ImageTextCarouselBiulderDefinition} from './image-text-carousel'
import {TpaLearningCenterConsentDefinition} from './tpa-learning-center-consent'
import {CategoryColumnsDefinition} from './category-columns'
import {contentCardsBuilderDefinition} from './content-cards'
import {ResetPasswordDefinition} from './reset-password/reset-password'

export const customComponents: RegisteredComponent[] = [
    TrustArcBannerDefinition,
    AccordionDetailDefinition,
    ResetPasswordDefinition,
    AccordionDefinition,
    AccordionItemDefinition,
    AccordionTitleDefinition,
    ArticleCardDefinition,
    ArticleTopicCardDefinition,
    ArticleGridDefinition,
    AccountDrawerDefinition,
    ProductRecommendationsDefinition,
    StandardBreadcrumbDefinition,
    BreadcrumbLinkDefinition,
    ContentTabsDefinition,
    TabButtonBoxDefinition,
    TabPanelBoxDefinition,
    CarouselDefinition,
    ProductCarouselDefinition,
    CarouselContentNavDefinition,
    CarouselContentDefinition,
    DeprecatedCarouselContentDefinition,
    DeprecatedCarouselDefinition,
    CarouselButtonDefinition,
    IconDefinition,
    AccordionLinkDefinition,
    IconLinksGridDefinition,
    NavDrawerDefinition,
    CategoriesDefinition,
    HeadingDefinition,
    BodyCopyDefinition,
    EyebrowDefinition,
    ButtonDefinition,
    LinkDefinition,
    PopoverDefinition,
    PopoverContainerDefinition,
    PopoverTriggerDefinition,
    PopoverContentDefinition,
    CategoryProductGridDefinition,
    CategoryFiltersBannerDefinition,
    MinicartDefinition,
    TextDefinition,
    LinkWrapperDefinition,
    SearchDefinition,
    LinkWrapperDefinition,
    GoalTileDefinition,
    GoalQuestionnaireDefinition,
    LearningCenterModuleDefinition,
    EmailSignupDefinition,
    GoalBannerDefinition,
    LearningCenterBreadcrumbDefinition,
    LearningCenterArticleBreadcrumbDefinition,
    ThemeBoxDefinition,
    LearningCenterLevelsDefinition,
    GuestContentDefinition,
    AuthContentDefinition,
    LmnAllowedContentDefinition,
    LmnSuppressedContentDefinition,
    UserNameDefinition,
    MainNavDefinition,
    StickyWrapperDefinition,
    SortPopoverDefinition,
    ExpandableContentDefinition,
    PerksAndRewardsSectionDefinition,
    SignOutButtonDefinition,
    ToggleTextButtonDefinition,
    ProductTileDefinition,
    ExpenseDashboardDefinition,
    DownloadAssetButtonDefinition,
    ModalContainerDefinition,
    ModalTriggerDefinition,
    ModalContentDefinition,
    ToggleContextProviderDefinition,
    ToggleContentDefinition,
    ToggleButtonDefinition,
    TpaBalanceDefinition,
    BuilderDrawerFiltersDefinition,
    HeaderBannerDefinition,
    AlertBarDefinition,
    PlpBuilderBlockDefinition,
    InteractiveSpendingToolDefinition,
    ThreeColumnHeroDefinition,
    TwoColumnHeroDefinition,
    SingleColumnHeroDefinition,
    HomepageCarouselGridBuilderDefinition,
    CategoryColumnsDefinition,
    SingleColumnHeroDefinition,
    ImageTextCarouselBiulderDefinition,
    TpaLearningCenterConsentDefinition,
    contentCardsBuilderDefinition
] satisfies RegisteredComponent[]
